import { render, staticRenderFns } from "./reportes.vue?vue&type=template&id=3b24098b"
import script from "./reportes.vue?vue&type=script&lang=js"
export * from "./reportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports